import { useEffect, useState } from "react";
import { useLocalAuth } from "@/components/auth/ClerkAuthProvider";
import { ShieldAlert, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApi, useResource } from "@/lib/api";
import { SettingsContext } from "@/lib/settings";

const SettingsProvider = ({ children }) => {
  const { data } = useResource("/settings");
  return <SettingsContext.Provider value={data || {}}>{children}</SettingsContext.Provider>;
};

export const AccessGate = ({ children }) => {
  const api = useApi();
  const {token, signOut} = useLocalAuth();
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!token) {
      setState("loading");
      return;
    }
    setState("loading");
    api.get("/me")
      .then((r) => setState(r.data.authorized ? "ok" : "denied"))
      .catch(() => setState("denied"));
  }, [api, token]);

  if (state === "loading") {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="access-loading">
        <Loader2 className="h-6 w-6 animate-spin text-sky-600" />
      </div>
    );
  }
  if (state === "denied") {
    return (
      <div className="min-h-screen grid place-items-center px-6" data-testid="access-denied">
        <div className="surface max-w-md p-8 text-center">
          <ShieldAlert className="mx-auto h-10 w-10 text-amber-500" />
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Acesso não autorizado</h1>
          <p className="mt-2 text-sm text-slate-600">
            Este e-mail não tem permissão para acessar o consultório. Entre com o e-mail autorizado.
          </p>
          <Button onClick={() => {signOut();window.location.href="/sign-in";}} className="mt-6 rounded-full" data-testid="access-denied-signout">Sair e trocar de conta</Button>
        </div>
      </div>
    );
  }
  return <SettingsProvider>{children}</SettingsProvider>;
};
